import { gql } from '@apollo/client';

export const GET_REPORTING_PERIODS_QUERY = gql`
  query getReportingPeriods($group_id: String, $company_id: String, $locked: Boolean) {
    reporting_periods(group_id: $group_id, company_id: $company_id, locked: $locked) {
      id
      deleted
      start
      end
      locked
      name
      reporting_period_group {
        name
        id
      }
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const GET_REPORTING_PERIODS_BY_GROUP_QUERY = gql`
  query getReportingPeriodsByGroup(
    $group_id: String
    $company_id: String
    $reporting_period_group_id: String
  ) {
    reporting_periods_by_group(
      group_id: $group_id
      company_id: $company_id
      reporting_period_group_id: $reporting_period_group_id
    ) {
      id
      deleted
      start
      end
      locked
      name
      reporting_period_group {
        id
        name
        reference {
          path
        }
      }
    }
  }
`;
